import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import WeeklyBriefPage from "@/pages/WeeklyBrief";

export const Route = createFileRoute("/_app/weekly/$id")({
  component: () => (
    <PageGate pageKey="weekly-brief"><WeeklyBriefPage /></PageGate>
  ),
});
